export const localStorageKeyConstants = Object.freeze({
  APP_VERSION: 'appVersion',
  API_BASE_URL: 'apiBaseUrl',
  WMS_TABLEAU_DASHBOARD_URL: 'wmsTableauDashboardUrl',
  DMS_TABLEAU_DASHBOARD_URL: 'dmsTableauDashboardUrl',
  STATE_TABLEAU_DASHBOARD_URL: 'stateTableauDashboardUrl',
  STORED_USERNAME: 'storedUsername',
  CLIENT_CODE: 'clientCode',
  WAREHOUSE_CODE: 'warehouseCode',
  DMS_FLAG: 'dmsFlag',
})
